import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initMercadoPago } from '@mercadopago/sdk-react';
// REACT_APP_MP_PUBLIC_KEY ya existía en .env pero no se leía acá (dead
// code) — el TEST- hardcodeado quedaba de fallback para que siga andando
// en local si esa variable no está seteada.
const MP_PUBLIC_KEY = process.env.REACT_APP_MP_PUBLIC_KEY || "TEST-219dc6f1-f8a2-4bef-8254-34eede5c49ec";
initMercadoPago(MP_PUBLIC_KEY, { locale: 'es-AR' });
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
